<template>
  <div class="staff-chat-view">
    <div class="staff-chat-view-search">
      <el-radio-group
        v-model="radio"
        size="small"
        style="margin-right: 10px"
        @change="selectSearchType"
        :disabled="isRequestSuccess"
      >
        <el-radio-button label="今日"></el-radio-button>
        <el-radio-button label="昨日"></el-radio-button>
        <el-radio-button label="近7日"></el-radio-button>
        <el-radio-button label="近30日"></el-radio-button>
      </el-radio-group>
      <el-date-picker
        size="small"
        :editable="false"
        v-model="searchDate"
        type="daterange"
        @change="dateChange"
        value-format="yyyy-MM-dd"
        range-separator="~"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width:240px;margin-right: 10px"
        :disabled="isRequestSuccess"
      >
      </el-date-picker>
      <!-- <el-button
        size="small"
        type="primary"
        style="margin-right: 268px"
        @click="reset"
        :disabled="isRequestSuccess"
        >重置</el-button
      > -->
    </div>
    <div class="below">
      <div class="l-nav">
        <el-scrollbar>
          <el-aside class="chat-type" style="height: 60vh; width: 100%;">
            <div class="menu-item">沟通客户</div>
            <!-- <el-menu @select="handleSelect" :default-active="activePath">
              <el-menu-item
              
                v-for="item in dataFirst"
                :key="item.id"
                :index="item.id + ''"
              >
                <span slot="title">{{ item.name }} </span>
              </el-menu-item>
            </el-menu> -->
          </el-aside>
        </el-scrollbar>
      </div>
      <div class="middle">
        <!-- 新版外部好友组件 -->
        <SelectExternalFriend
          :uid="uid"
          ref="selectExternalFriend"
          v-if="activePath == '1'"
          @requestSuccess="requestSuccess"
        />
        <!-- 敏感词组件 -->
        <StaffSen :uid="uid" v-else="activePath == '2'" ref="StaffSen" />
      </div>
    </div>
  </div>
</template>
<script>
import SelectExternalFriend from "./SelectExternalFriend"; //新版外部好友组件
import StaffSen from "../StaffSen";
export default {
  name: "ChatContent",
  props: {
    // 员工 uid
    idData: {
      type: String,
      default: "",
      required: true,
    },
  },
  components: {
    SelectExternalFriend,
    StaffSen,
  },
  data() {
    return {
      // 日期数据
      searchDate: [],
      // 开始时间
      startTime: "2021-01-01",
      // 结束时间
      endTime: this.getToday(),
      // 未选择时默认开始时间
      startTimeDefault: "2021-01-01",
      // 未选择时默认结束时间
      // endTimeDefault: '',
      // 员工id
      uid: this.idData,
      // 快捷选择的值
      radio: "近7日",
      // 类型tab 1:沟通用户 2:敏感词
      activePath: "1",
      // 快捷选择按钮
      dataFirst: [{ name: "沟通客户", id: 1 }],
      /** 是否新版会话存档 */
      isNewEdition: false,
      /** 接口是否请求完毕 */
      isRequestSuccess: true,
      // datechushi: [],
    };
  },
  methods: {
    // 切换调用哪个组件的方法
    useFunction() {
      switch (this.activePath) {
        case "1":
          this.$nextTick(() => {
            this.$refs.selectExternalFriend.displayContact(
              this.uid,
              this.startTime,
              this.endTime,
              this.radio
            );
          });
          break;
        case "2":
          this.$nextTick(() => {
            this.$refs.StaffSen.init(this.uid, this.startTime, this.endTime);
          });
      }
    },

    /** 快捷选择变化 */
    selectSearchType() {
      this.searchDate = [];
      if (this.radio == "今日") {
        this.startTime = this.getToday();
        this.endTime = this.getToday();
      } else if (this.radio == "昨日") {
        this.startTime = this.getYesterday();
        this.endTime = this.getYesterday();
      } else if (this.radio == "近7日") {
        const [startDate, endDate] = this.getDateRange(7);
        this.startTime = startDate;
        this.endTime = endDate;
      } else if (this.radio == "近30日") {
        const [startDate, endDate] = this.getDateRange(30);
        this.startTime = startDate;
        this.endTime = endDate;
      }
      this.useFunction();
    },

    /** 时间变化 */
    dateChange() {
      this.radio = "";
      if (this.searchDate != null) {
        this.startTime = this.searchDate[0];
        this.endTime = this.searchDate[1];
        this.radio = "";
      } else {
        this.startTime = this.startTimeDefault;
        this.endTime = this.getToday();
      }
      this.useFunction();
    },

    /** 重置选择功能 */
    reset() {
      this.searchDate = [];
      this.startTime = this.startTimeDefault;
      this.endTime = this.getToday();
      this.radio = "";
      this.useFunction();
    },

    // 左部菜单项点击事件
    async handleSelect(key, keyPath) {
      if (this.activePath !== key) {
        this.activePath = key;
        await this.reset();
        this.useFunction();
      }
    },

    /** 获取当天日期 */
    getToday() {
      var date = new Date();
      var y = date.getFullYear();
      var m =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return y + "-" + m + "-" + d;
    },

    /** 获取前一天时间 */
    getYesterday() {
      var date = new Date();
      date = new Date(date - 1000 * 60 * 60 * 24);
      var y = date.getFullYear();
      var m =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return y + "-" + m + "-" + d;
    },

    requestSuccess(val) {
      this.isRequestSuccess = val;
    },
    /** 获取从今天开始 */
    getDateRange(daysBefore) {
      // 获取当前日期（本地时区）
      const today = new Date();

      // 计算起始日期：今天减去(daysBefore-1)天（包含今天）
      const startDate = new Date(today);
      startDate.setDate(today.getDate() - (daysBefore - 1));

      // 日期格式化函数
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      return [formatDate(startDate), formatDate(today)];
    },
  },

  async created() {
    // this.endTime = this.endTimeDefault = this.getToday();
    this.isNewEdition = window.localStorage.getItem("isNewEdition");
    const [startDate, endDate] = await this.getDateRange(7);
    this.startTime = startDate;
    this.endTime = endDate;
    // if(!this.isNewEdition)  this.dataFirst.push({ name: "敏感词", id: 2 })
    this.useFunction();
    // this.activePath = '1';
  },
};
</script>
<style lang="scss">
.staff-chat-view {
  .staff-chat-view-search {
    margin-bottom: 10px;
  }
  .below {
    display: flex;
    justify-content: space-around;
    border: 1px solid #e6e6e6;
    .l-nav {
      flex: 3;
      border-right: 1px solid #e6e6e6;
    }
    .middle {
      flex: 10;
    }
  }
  .el-menu {
    border-right: 0 !important;
  }
  .ff {
    color: rgb(130, 133, 133);
  }
  ::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: rgba(177, 181, 189, 0.5);
    border-radius: 5px;
  }
  .menu-item {
    height: 50px;
    padding-left: 20px;
    line-height: 50px;
    border-bottom: 1px solid #f4f6f9;
  }
}
</style>
